import { Box, Typography, Container, Card, CardHeader, CardContent, Avatar } from '@mui/material';
import React from "react";
import Slider from "react-slick";
import './TestimonialSliderSm.css'

const NextArrow = ({ onClick }) => {
    return (
        <Box sx={{ py: 1, px: { xs: 1.875, sm: 2.625, md: 3.375, lg: 4.125 } }} className="arrowSign nextBtn" onClick={onClick}>
            <i className="fas fa-arrow-right"></i>
        </Box>
    );
};

const PrevArrow = ({ onClick }) => {
    return (
        <Box sx={{ py: 1, px: { xs: 1.875, sm: 2.625, md: 3.375, lg: 4.125 } }} className="arrowSign prevBtn" onClick={onClick}>
            <i className="fas fa-arrow-left"></i>
        </Box>
    );
};

export default function TestimonialSliderSm() {
    var settings = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        lazyLoad: true,
        nextArrow: <NextArrow />,
        prevArrow: <PrevArrow />
    }

    return (
        <Container sx={{ position: 'relative' }}>
            <Slider {...settings}>

                {/* Slide-1 */}
                <Box sx={{ mb: 5, py: 4, px: 2 }} >
                    <Card className="hover-testimonial" sx={{ width: '75%', background: '#FFFFFF', boxShadow: '0px 0px 5px rgba(0, 0, 0, 0.08)', borderRadius: '7px' }}>
                        <CardHeader
                            avatar={
                                <Avatar
                                    alt=""
                                    src="https://i.ibb.co/4YFNHDT/textimonial1.png"
                                    sx={{ width: 45, height: 45 }}
                                />
                            }
                            title="Lorem Ipsum"
                            subheader="Tokyo, Japan"
                        />

                        <CardContent>
                            <Typography
                                sx={{ fontWeight: 500, fontStyle: 'normal', fontSize: 12, lineHeight: '10px', color: '#404040', pb: .5, textAlign: 'left' }}
                                variant="h1"
                                noWrap
                                component="div"
                            >Awesome Work</Typography>
                            <Typography
                                sx={{ fontWeight: 300, fontStyle: 'normal', fontSize: 10, lineHeight: '14px', color: '#5B5B5B', textAlign: 'justify' }}
                                variant="h1"
                                noWrap
                                component="div"
                            >Lorem ipsum dolor sit amet, consectetur asbi<br /> adipiscing Amet pharetra, amaecena. Adipiscing<br /> Lorem ipsum dolor sit amet.</Typography>
                        </CardContent>
                    </Card>
                </Box>

                {/* Slide-2 */}
                <Box sx={{ mb: 5, py: 4, px: 2 }}>
                    <Card className="hover-testimonial" sx={{ width: '75%', background: '#FFFFFF', boxShadow: '0px 0px 5px rgba(0, 0, 0, 0.08)', borderRadius: '7px' }}>
                        <CardHeader
                            avatar={
                                <Avatar
                                    alt=""
                                    src="https://i.ibb.co/51Pp6LF/textimonial2.png"
                                    sx={{ width: 45, height: 45 }}
                                />
                            }
                            title="Lorem Ipsum"
                            subheader="Tokyo, Japan"
                        />

                        <CardContent>
                            <Typography
                                sx={{ fontWeight: 500, fontStyle: 'normal', fontSize: 12, lineHeight: '10px', color: '#404040', pb: .5, textAlign: 'left' }}
                                variant="h1"
                                noWrap
                                component="div"
                            >Awesome Work</Typography>
                            <Typography
                                sx={{ fontWeight: 300, fontStyle: 'normal', fontSize: 10, lineHeight: '14px', color: '#5B5B5B', textAlign: 'justify' }}
                                variant="h1"
                                noWrap
                                component="div"
                            >Lorem ipsum dolor sit amet, consectetur asbi<br /> adipiscing Amet pharetra, amaecena. Adipiscing<br /> Lorem ipsum dolor sit amet.</Typography>
                        </CardContent>
                    </Card>
                </Box>

                {/* Slide-3 */}
                <Box sx={{ mb: 5, py: 4, px: 2 }}>
                    <Card className="hover-testimonial" sx={{ width: '75%', background: '#FFFFFF', boxShadow: '0px 0px 5px rgba(0, 0, 0, 0.08)', borderRadius: '7px' }}>
                        <CardHeader
                            avatar={
                                <Avatar
                                    alt=""
                                    src="https://i.ibb.co/Y8XNWVC/textimonial3.png"
                                    sx={{ width: 45, height: 45 }}
                                />
                            }
                            title="Lorem Ipsum"
                            subheader="Mumbai, India"
                        />

                        <CardContent>
                            <Typography
                                sx={{ fontWeight: 500, fontStyle: 'normal', fontSize: 12, lineHeight: '10px', color: '#404040', pb: .5, textAlign: 'left' }}
                                variant="h1"
                                noWrap
                                component="div"
                            >Awesome Work</Typography>
                            <Typography
                                sx={{ fontWeight: 300, fontStyle: 'normal', fontSize: 10, lineHeight: '14px', color: '#5B5B5B', textAlign: 'justify' }}
                                variant="h1"
                                noWrap
                                component="div"
                            >Lorem ipsum dolor sit amet, consectetur asbi<br /> adipiscing Amet pharetra, amaecena. Adipiscing<br /> Lorem ipsum dolor sit amet.</Typography>
                        </CardContent>
                    </Card>
                </Box>

                {/* Slide-4 */}
                <Box sx={{ mb: 5, py: 4, px: 2 }}>
                    <Card className="hover-testimonial" sx={{ width: '75%', background: '#FFFFFF', boxShadow: '0px 0px 5px rgba(0, 0, 0, 0.08)', borderRadius: '7px' }}>
                        <CardHeader
                            avatar={
                                <Avatar
                                    alt=""
                                    src="https://i.ibb.co/51Pp6LF/textimonial2.png"
                                    sx={{ width: 45, height: 45 }}
                                />
                            }
                            title="Lorem Ipsum"
                            subheader="Mumbai, India"
                        />

                        <CardContent>
                            <Typography
                                sx={{ fontWeight: 500, fontStyle: 'normal', fontSize: 12, lineHeight: '10px', color: '#404040', pb: .5, textAlign: 'left' }}
                                variant="h1"
                                noWrap
                                component="div"
                            >Awesome Work</Typography>
                            <Typography
                                sx={{ fontWeight: 300, fontStyle: 'normal', fontSize: 10, lineHeight: '14px', color: '#5B5B5B', textAlign: 'justify' }}
                                variant="h1"
                                noWrap
                                component="div"
                            >Lorem ipsum dolor sit amet, consectetur asbi<br /> adipiscing Amet pharetra, amaecena. Adipiscing<br /> Lorem ipsum dolor sit amet.</Typography>
                        </CardContent>
                    </Card>
                </Box>
            </Slider>
        </Container >
    );
}